import { render, staticRenderFns } from "./siGoodsUnSold.vue?vue&type=template&id=368a8a9c&"
import script from "./siGoodsUnSold.vue?vue&type=script&lang=js&"
export * from "./siGoodsUnSold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "siGoodsUnSold.vue"
export default component.exports